import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { FaChevronUp, FaFilePdf } from "react-icons/fa";
import Loader from '../../../components/Loader/Loader';
import { Row, Col } from 'react-bootstrap';

import SelectFild from '../../../components/SelectFild/SelectFild';
import TimeFild from '../../../components/DateTimePicker/TimeFild';
import UploadWithSignature from '../../../components/UploadWithSignature/UploadWithSignature';

import { getStaff, postDesignations, postWhoWasInvolveStore } from '../../../apiservices/ApiServices';
import { wasInvolvedFrmvalidationSchema } from '../../../schemas';

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import 'dayjs/locale/en';

const WhoWasInvolvedForms = ({ details, postUpdateData, toast }) => {
    const [isLoadings, setLoadings] = useState(false);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [staffCategorys, setStaffCategorys] = useState([]);
    const [designationsMap, setDesignationsMap] = useState({});
    const [localTime, setLocalTime] = useState(dayjs().format('HH:mm'));


    const getStaffs = async () => {
        try {
            const res = await getStaff();
            setStaffCategorys(res.data.data);

        } catch (error) {
        }
    };

    const fetchDesignationsForCategory = async (categoryId, index) => {
        try {
            const res = await postDesignations({ staff_category_id: categoryId });
            setDesignationsMap(prev => ({
                ...prev,
                [index]: res.data.data
            }));
        } catch (error) {
            console.error('Failed to fetch designations', error?.response?.data?.message);
        }
    };

    useEffect(() => {
        getStaffs();
    }, []);

    const emptyStatement = {
        who: details?.who,
        id: '',
        nameofPerson: '',
        staffCategory: '',
        designation: '',
        staffIdentificationNo: '',
        staffShiftTiming: localTime,
        staffContactDetails: '',
        staffEmail: '',
        images: '',
    };

    const mapApiDataToFormikValues = (apiData) => {
        return apiData?.who_was_involved?.map(item => ({
            id: item.id || '',
            nameofPerson: item.name_of_person || '',
            staffCategory: item.staff_category || '',
            designation: item.designation || '',
            staffIdentificationNo: item.staff_identification_no || '',
            staffShiftTiming: item.staff_shift_timing || localTime,
            staffContactDetails: item.staff_contact_details || '',
            staffEmail: item.staff_email || '',
            images: item.staff_images_json || [],
        })) || [];
    };

    const [initialFormikValues, setInitialFormikValues] = useState({
        wasInvolved: [emptyStatement]
    });

    useEffect(() => {
        if (details?.who_was_involved?.length) {
            const prefill = mapApiDataToFormikValues(details);
            setFieldValue('wasInvolved', prefill);

            prefill.forEach((item, index) => {
                if (item.staffCategory) {
                    fetchDesignationsForCategory(item.staffCategory, index);
                }
            });
        }


    }, [details]);

    const transformFormValuesToPostData = (values) => {
        const formData = new FormData();
        formData.append('incident_header_id', details.header_id);
        values.wasInvolved.forEach((item, index) => {
            formData.append(`staff[${index}][id]`, item.id);
            formData.append(`staff[${index}][name_of_person]`, item.nameofPerson);
            formData.append(`staff[${index}][staff_category]`, item.staffCategory);
            formData.append(`staff[${index}][designation]`, item.designation);
            formData.append(`staff[${index}][staff_identification_no]`, item.staffIdentificationNo);
            formData.append(`staff[${index}][staff_shift_timing]`, item.staffShiftTiming);
            formData.append(`staff[${index}][staff_contact_details]`, item.staffContactDetails);
            formData.append(`staff[${index}][staff_email]`, item.staffEmail);

            uploadedFiles.forEach((file, ind) => {
                console.log('file.signatureData', file)

                if (file.originalFile.type === 'application/pdf') {
                    formData.append(`staff_images[${index}][${ind}]`, file.originalFile);
                }

                if (file.signatureData) {
                    const blob = dataURLtoBlob(file.signatureData);
                    formData.append(`staff_images[${index}][${ind}]`, blob, `signature_${file.originalFile.name}`);
                }
            });

        });

        return formData;
    };

    const postWhoWasInvolveStores = async (postdata) => {
        setLoadings(true);
        try {
            const res = await postWhoWasInvolveStore(postdata);
            toast.success(res.data.message);
            postUpdateData();
        } catch (error) {
            toast.error(error?.response?.data?.message || 'Something went wrong');
        } finally {
            setLoadings(false);
        }
    };

    const addStatement = () => {
        setFieldValue('wasInvolved', [...values.wasInvolved, { ...emptyStatement }]);
    };

    const removeStatement = (index) => {
        const updated = values.wasInvolved.filter((_, i) => i !== index);
        setFieldValue('wasInvolved', updated);
    };

    const formik = useFormik({
        iinitialValues: {
            wasInvolved: [emptyStatement]
        },
        validationSchema: '',
        initialValues: initialFormikValues,
        enableReinitialize: true,
        onSubmit: async (values) => {
            const postdata = transformFormValuesToPostData(values);
            await postWhoWasInvolveStores(postdata);
            console.log('postdata', postdata);
        },
    });
    const { values, handleChange, handleBlur, handleSubmit, setFieldValue, errors, touched, } = formik;

    const dataURLtoBlob = (dataURL) => {
        const arr = dataURL.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new Blob([u8arr], { type: mime });
    };

    useEffect(() => {
        let parsedWho = [];

        try {
            parsedWho = JSON.parse(details?.who || '[]');
            if (!Array.isArray(parsedWho)) parsedWho = [];
        } catch (e) {
            parsedWho = [];
        }

        const htmlList = `<ul>${parsedWho.map(item => `<li>${item}</li>`).join('')}</ul>`;
        setFieldValue('who', htmlList);
    }, [details, setFieldValue]);

    return (
        <>
            <div className="GroupList fieldset">
                <div className='toggle-button'>
                    <h2 className="listTitle">Who Was Involved</h2>
                    <div className='btnColaps'><FaChevronUp /></div>
                </div>
                <div className="subFilds">
                    <form onSubmit={handleSubmit} autoComplete="off">
                        {details?.who == 'undefined' || details?.who == '' ? null : (
                            <div className="form-box mb-4">
                                <div className="fieldset intl">
                                    <h1>Initial Who Was Involved</h1>
                                    <div className="form-group">
                                        <div dangerouslySetInnerHTML={{ __html: values.who }}></div>
                                    </div>
                                </div>
                            </div>
                        )}
                        <div id="wasinnvolved" className="multiGrop">
                            {values.wasInvolved.map((wasInvolve, index) => (
                                <div key={index} className="fieldset mainFS">
                                    <div className="statetitle_btn">
                                        <h1 className="titles">Who Was Involved <span>{index + 1}</span></h1>
                                        <div className="addreovebtns">
                                            <button type="button" className="btn add-btn" onClick={addStatement}>+</button>
                                            {values.wasInvolved.length > 1 && (
                                                <button type="button" className="btn remove-btn" onClick={() => removeStatement(index)}>-</button>
                                            )}
                                        </div>
                                    </div>
                                    <div className='formsBox'>
                                        <Row>
                                            <Col md={4}>
                                                <div className="form-group">
                                                    <label>Name of Person</label>
                                                    <input type="text"
                                                        name="nameofPerson"
                                                        className="form-control"
                                                        autoComplete='off'
                                                        value={wasInvolve.nameofPerson}
                                                        onChange={(e) => setFieldValue(`wasInvolved[${index}].nameofPerson`, e.target.value)}
                                                    />
                                                    {errors?.wasInvolved?.[index]?.nameofPerson &&
                                                        touched?.wasInvolved?.[index]?.nameofPerson && (
                                                            <p className="errormsg">{errors.wasInvolved[index].nameofPerson}</p>
                                                        )}
                                                </div>
                                            </Col>
                                            <Col md={4}>
                                                <div className="form-group">
                                                    <label>Staff Category</label>
                                                    <SelectFild
                                                        Firstop='Select Staff Category'
                                                        selectName={`wasInvolved[${index}].staffCategory`}
                                                        options={staffCategorys}
                                                        value={values.wasInvolved[index].staffCategory}
                                                        onChange={(selectedOption) => {
                                                            setFieldValue(`wasInvolved[${index}].staffCategory`, selectedOption?.value || "");
                                                            fetchDesignationsForCategory(selectedOption?.value || "", index);
                                                        }}
                                                        onBlur={handleBlur}
                                                    />
                                                    {errors?.wasInvolved?.[index]?.staffCategory &&
                                                        touched?.wasInvolved?.[index]?.staffCategory && (
                                                            <p className="errormsg">{errors.wasInvolved[index].staffCategory}</p>
                                                        )}
                                                </div>
                                            </Col>
                                            <Col md={4}>
                                                <div className="form-group">
                                                    <label>Designation</label>
                                                    <SelectFild
                                                        Firstop='Select Designation'
                                                        selectName={`wasInvolved[${index}].designation`}
                                                        options={designationsMap[index] || []}
                                                        value={values.wasInvolved[index].designation}
                                                        onChange={(selectedOption) => setFieldValue(`wasInvolved[${index}].designation`, selectedOption?.value || "")}
                                                        onBlur={handleBlur}
                                                    />
                                                    {errors?.wasInvolved?.[index]?.designation &&
                                                        touched?.wasInvolved?.[index]?.designation && (
                                                            <p className="errormsg">{errors.wasInvolved[index].designation}</p>
                                                        )}
                                                </div>
                                            </Col>
                                            <Col md={4}>
                                                <div className="form-group">
                                                    <label>Staff Identification No </label>
                                                    <input type="text"
                                                        name="staffIdentificationNo"
                                                        className="form-control"
                                                        autoComplete='off'
                                                        value={wasInvolve.staffIdentificationNo}
                                                        onChange={(e) => setFieldValue(`wasInvolved[${index}].staffIdentificationNo`, e.target.value)}
                                                    />
                                                    {errors?.wasInvolved?.[index]?.staffIdentificationNo &&
                                                        touched?.wasInvolved?.[index]?.staffIdentificationNo && (
                                                            <p className="errormsg">{errors.wasInvolved[index].staffIdentificationNo}</p>
                                                        )}
                                                </div>
                                            </Col>
                                            <Col md={4}>
                                                <div className="form-group">
                                                    <label>Staff Shift Timing</label>
                                                    <TimeFild
                                                        value={values.wasInvolved[index].staffShiftTiming}
                                                        onChange={(time) => setFieldValue(`wasInvolved[${index}].staffShiftTiming`, time)}
                                                        format="local"
                                                    />
                                                    {errors?.wasInvolved?.[index]?.staffShiftTiming &&
                                                        touched?.wasInvolved?.[index]?.staffShiftTiming && (
                                                            <p className="errormsg">{errors.wasInvolved[index].staffShiftTiming}</p>
                                                        )}
                                                </div>
                                            </Col>
                                            <Col md={4}>
                                                <div className="form-group">
                                                    <label>Staff contact Details</label>
                                                    <input type="text"
                                                        name="staffContactDetails"
                                                        className="form-control"
                                                        autoComplete='off'
                                                        value={wasInvolve.staffContactDetails}
                                                        onChange={(e) => setFieldValue(`wasInvolved[${index}].staffContactDetails`, e.target.value)}
                                                    />
                                                    {errors?.wasInvolved?.[index]?.staffContactDetails &&
                                                        touched?.wasInvolved?.[index]?.staffContactDetails && (
                                                            <p className="errormsg">{errors.wasInvolved[index].staffContactDetails}</p>
                                                        )}
                                                </div>
                                            </Col>
                                            <Col md={4}>
                                                <div className="form-group">
                                                    <label>Staff Email</label>
                                                    <input type="text"
                                                        name="staffEmail"
                                                        className="form-control"
                                                        autoComplete='off'
                                                        value={wasInvolve.staffEmail}
                                                        onChange={(e) => setFieldValue(`wasInvolved[${index}].staffEmail`, e.target.value)}
                                                    />
                                                    {errors?.wasInvolved?.[index]?.staffEmail &&
                                                        touched?.wasInvolved?.[index]?.staffEmail && (
                                                            <p className="errormsg">{errors.wasInvolved[index].staffEmail}</p>
                                                        )}
                                                </div>
                                            </Col>
                                        </Row>
                                        <UploadWithSignature onFilesChange={setUploadedFiles} />

                                        {Array.isArray(wasInvolve.images) && (
                                            <div className='previewsimges'>
                                                {wasInvolve.images.map((fileUrl, index) => {
                                                    if (fileUrl.toLowerCase().endsWith('.pdf')) {
                                                        return (
                                                            <div key={index} className='imageboxs'>
                                                                <div className='imgs pdfs'>
                                                                    <div>
                                                                        <div className="pdf-icon">
                                                                            <FaFilePdf size={48} color="#e74c3c" />
                                                                        </div>
                                                                        <a href={fileUrl} target="_blank" className='btn btn-orange' rel="noopener noreferrer">view Pdf</a>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        );
                                                    }
                                                    return (
                                                        <div key={index} className='imageboxs'>
                                                            <div className='imgs'>
                                                                <img src={fileUrl} alt={`Image ${index + 1}`} />
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            ))}
                            <div className="button-boxs grid pt-2 pb-2">
                                <button type='submit' className='btn btn-orange'>Submit</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            {isLoadings ? <Loader /> : null}
        </>
    );
}

export default WhoWasInvolvedForms